"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    axisDefaults: Object,
    categoryAxis: Array | Object,
    chartArea: Object,
    data: Array,
    dataSource: Object,
    autoBind: Boolean,
    plotArea: Object,
    pointWidth: Number,
    renderAs: String,
    series: Array,
    seriesColors: Array,
    seriesDefaults: Object,
    theme: String,
    tooltip: Object,
    transitions: Boolean,
    type: String,
    valueAxis: Array | Object,

    // Events
    axisLabelClick: Function,
    dataBound: Function,
    dragStart: Function,
    drag: Function,
    dragEnd: Function,
    plotAreaClick: Function,
    seriesClick: Function,
    seriesHover: Function,
    zoomStart: Function,
    zoom: Function,
    zoomEnd: Function
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts-vue-wrapper/dist/es/KendoSparkline/SparklineProps.js
// module id = 698
// module chunks = 0